module.exports = __webpack_public_path__ + "static/media/st-logo.e4135e1b.svg";